import { render, staticRenderFns } from "./new-company.vue?vue&type=template&id=38db2e71&scoped=true&"
import script from "./new-company.vue?vue&type=script&lang=js&"
export * from "./new-company.vue?vue&type=script&lang=js&"
import style0 from "./new-company.vue?vue&type=style&index=0&id=38db2e71&scoped=true&lang=scss&"
import style1 from "./new-company.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db2e71",
  null
  
)

export default component.exports